import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthDataService, RequiredPermissions } from '@uzurv/http';
import { isNullOrUndefined } from '@uzurv/core';

@Directive({
  selector: '[appRequiresPermissions]'
})
export class RequiresPermissionsDirective implements OnInit {
  @Input() appRequiresPermissions: RequiredPermissions;

  isVisible = false;

  /**
   * @param viewContainerRef
   * 	-- the location where we need to render the templateRef
   * @param templateRef
   *   -- the templateRef to be potentially rendered
   * @param authDataService
   *   -- will give us access to the permissions a user has
   */
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authDataService: AuthDataService
  ) {}

  ngOnInit() {
    if (isNullOrUndefined(this.appRequiresPermissions)) {
      this.isVisible = false;
      this.viewContainerRef.clear();
      return;
    }

    if (!this.authDataService.getPermissions()) {
      this.viewContainerRef.clear();
      return;
    }

    // If the user has the permissions needed to
    // render this component we can add it
    if (this.authDataService.hasPermission(this.appRequiresPermissions)) {
      // If it is already visible (which can happen if
      // his permissions changed) we do not need to add it a second time
      if (!this.isVisible) {
        // We update the `isVisible` property and add the
        // templateRef to the view using the
        // 'createEmbeddedView' method of the viewContainerRef
        this.isVisible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      // If the user does not have permission,
      // we update the `isVisible` property and clear
      // the contents of the viewContainerRef
      this.isVisible = false;
      this.viewContainerRef.clear();
    }
  }
}
